import Toastr from '../../../components/Toastr'

const parent = 'SETTING_'

const initialState = {
  warranties: [],
  warranty: null,
  meta: {},
  loading: false,
  detailLoading: false,
  saving: false,
  error: null,
}

const apiErrorMessage = (payload, fallback) => {
  const data = payload?.response?.data || payload?.data || {}
  return data.error || data?.meta?.message || data.message || fallback
}

export default function warrantyReducer(state = initialState, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${parent}WARRANTIES_LOAD_PENDING`:
      return { ...state, loading: true, error: null }

    case `${parent}WARRANTY_LOAD_PENDING`:
      return { ...state, detailLoading: true, warranty: null, error: null }

    case `${parent}WARRANTY_CREATE_PENDING`:
    case `${parent}WARRANTY_UPDATE_PENDING`:
    case `${parent}WARRANTY_DELETE_PENDING`:
      return { ...state, saving: true, error: null }

    case `${parent}WARRANTIES_LOAD_REJECTED`:
      return { ...state, loading: false, error: action.payload }

    case `${parent}WARRANTY_LOAD_REJECTED`:
      return { ...state, detailLoading: false, warranty: null, error: action.payload }

    case `${parent}WARRANTY_CREATE_REJECTED`:
    case `${parent}WARRANTY_UPDATE_REJECTED`:
    case `${parent}WARRANTY_DELETE_REJECTED`: {
      Toastr.handleShow(
        false,
        apiErrorMessage(action.payload, 'Unable to save warranty.'),
        action.payload?.response?.status || 422
      )
      return { ...state, saving: false, error: action.payload }
    }

    case `${parent}WARRANTIES_LOAD_FULFILLED`:
      return {
        ...state,
        loading: false,
        warranties: response?.warranties || [],
        meta: response?.meta || {},
      }

    case `${parent}WARRANTY_LOAD_FULFILLED`:
      return {
        ...state,
        detailLoading: false,
        warranty: response?.warranty || null,
      }

    case `${parent}WARRANTY_CREATE_FULFILLED`:
    case `${parent}WARRANTY_UPDATE_FULFILLED`:
    case `${parent}WARRANTY_DELETE_FULFILLED`:
      if (response?.success === false) {
        Toastr.handleShow(false, response.error || response?.meta?.message || 'Unable to save warranty.', 422)
        return { ...state, saving: false, error: response }
      }
      if (response?.meta?.message) {
        Toastr.handleShow(true, response.meta.message, 201)
      }
      return {
        ...state,
        saving: false,
        warranty: response?.warranty || state.warranty,
      }

    case `${parent}WARRANTY_CLEAR`:
      return { ...state, warranty: null, detailLoading: false }

    default:
      return state
  }
}
